export default jQuery;
